"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnLastName = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../../../utils/classFunctions");
const Icon_1 = require("../../../../../Icon");
const tariffGroupMapper_1 = require("../../../../../TariffsTable/tariffGroupMapper");
const Tooltip_1 = require("../../../../../Tooltip");
require("./index.scss");
const className = 'flight-passenger-list-last-name';
const ColumnLastName = () => {
    return {
        id: 'lastName',
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/LastName:Title', defaultMessage: 'Last name' })),
        Cell: ({ row }) => {
            const { lastName, isAppeared, tariff } = row.original;
            const tariffCode = (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariff === null || tariff === void 0 ? void 0 : tariff.group.id);
            const classNames = (0, classFunctions_1.getClassNames)(className, [
                isAppeared === true ? 'appeared' : undefined,
                isAppeared === false ? 'not-appeared' : undefined,
            ]);
            return (react_1.default.createElement("div", { className: classNames },
                tariffCode === 'business' && (react_1.default.createElement("div", { className: `${className}__business-sign` },
                    react_1.default.createElement(Tooltip_1.Tooltip, { modificators: 'white', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/LastName:Business', defaultMessage: 'Business' }) },
                        react_1.default.createElement(Icon_1.Icon, { name: 'star' })))),
                isAppeared === false && (react_1.default.createElement(Tooltip_1.Tooltip, { modificators: 'white', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/LastName:NoShow', defaultMessage: 'No show' }) }, lastName)),
                isAppeared !== false && (lastName)));
        },
        canSort: true,
    };
};
exports.ColumnLastName = ColumnLastName;
//# sourceMappingURL=index.js.map